<template>
  <DocumentIconComponent v-if="fieldName" :fileName="fieldName" class="icon-component" />
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator'
import DocumentIconComponent from '@/components/FileManager/components/uploaderComponent/components/DocumentIconComponent.vue'

@Component({
  components: {
    DocumentIconComponent
  }
})
class FileIconColumnTemplateComponent extends Vue {
  data: any = null

  get fieldName() {
    return this.data?.initialFile || this.data?.documentName || null
  }
}

export default FileIconColumnTemplateComponent
</script>

<style lang="scss" scoped>
.icon-component {
  --icon-size: 22px;
}
</style>
